import React from 'react';
import PropTypes from 'prop-types';
import style from '../style.module.scss';
import {UnitStreakPlayer} from '../UnitStreakPlayer';
import {UNIT_STREAK_STATE} from '../StreakCounter.utils';

/**
 * StreakList:
 *  - Display a list of 8 streak Units
 */
export function StreakList(props) {
  const onPlayComplete = (index) => (state) => {
    if (allowCallback(index)) {
      props.updateStatus({index, state});
    }
  };

  const renderCount = (unit) => {
    if (unit.state === UNIT_STREAK_STATE.NEUTRAL)
      return <span className={style.flask_index}>{unit.index}</span>;
    else return;
  };

  const renderStreakUnit = (unit) => {
    return (
      <div key={unit.index} className={style.list_item}>
        <UnitStreakPlayer
          className={style.flask}
          state={unit.state}
          playComplete={onPlayComplete(unit.index)}>
          {renderCount(unit)}
        </UnitStreakPlayer>
      </div>
    );
  };

  return (
    <div className={style.list}>{props.streakUnits.map(renderStreakUnit)}</div>
  );
}

StreakList.propTypes = {
  /**
   * List of streak units
   */
  streakUnits: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Index of the Streak Unit
       */
      index: PropTypes.number,
      /**
       * Status of Streak Unit
       */
      state: PropTypes.oneOf(['NEUTRAL', 'STREAK', 'SUCCESS', 'FAIL']),
    })
  ),
  /**
   * Callback function to update Streak Status
   */
  updateStatus: PropTypes.func,
};

StreakList.defaultProps = {
  streakUnits: [],
};

/**
 * Function to throttle the updateStatus callback to only once
 *  - Callback is only allowed for the first UnitStreak Item
 */
function allowCallback(index) {
  if (index === 1) return true;
  else if (index > 8 && (index - 1) % 8 === 0) return true;
  else return false;
}
